import { useLocalStorage } from '@shared/hooks';

export const useAuthToken = () => {
	const { setItem, getItem, removeItem } = useLocalStorage();

	const setToken = (token: string) => setItem('token', token);

	const token = getItem('token');

	const removeToken = () => removeItem('token');

	return {
		setToken,
		token,
		removeToken,
	};
};
